<template>
	<div class="signIn">
		<el-row>
			<el-col type="flex" :span="10">
				<div class="left-main">
					<div class="title">
						<h2>欢迎使用</h2>
						<h1>{{ pageTitle }}</h1>
					</div>
					<el-form :rules="rules" :model="form" ref="loginForm" label-width="80px" label-position="top" @submit.native.prevent>
						<el-form-item label="账号：" class="label" prop="account">
							<el-input id="usernameId" v-model="form.account" prefix-icon="el-icon-user" placeholder="请输入登录账号" @keyup.enter.native="submit('loginForm')"></el-input>
						</el-form-item>
						<el-form-item label="密码：" class="label" prop="password">
							<el-input v-model="form.password" prefix-icon="el-icon-lock" placeholder="请输入登录密码" @keyup.enter.native="submit('loginForm')" show-password></el-input>
						</el-form-item>
						<!--验证码部分：仅对公有云有效-->
						<div v-if="isPublic">
							<el-row>
								<el-col :span="16">
									<el-form-item label="验证码" class="label" prop="inputCode">
										<el-input v-model="form.inputCode" prefix-icon="el-icon-user" placeholder="请输入验证码" @keyup.enter.native="submit('loginForm')"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<div style="margin-top:23px;">
										<img v-if="requestCodeSuccess" style="margin-top: 2px;" :src="randCodeImage" @click="handleChangeCheckCode" />
										<img v-else style="margin-top: 2px;" src="@/assets/images/checkcode.png" @click="handleChangeCheckCode" />
									</div>
								</el-col>
							</el-row>
						</div>
						<el-form-item>
							<el-checkbox v-model="form.rememberMe">记住密码</el-checkbox>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" class="block" native-type="submit" @click="submit('loginForm')" :loading="submiting">登录</el-button>
						</el-form-item>
					</el-form>
				</div>
			</el-col>
			<el-col :span="14">
				<div class="undraw">
					<img :src="picture" :alt="pageTitle" />
				</div>
			</el-col>
		</el-row>

		<el-dialog title="选择工厂" :visible.sync="dialogVisible" width="30%">
			<div>
				<div v-for="(item, index) in factoryList" :key="index" :style="{ marginBottom: '10px' }">
					<el-radio v-model="selectedFactoryName" :label="item.dbName" border :style="{ width: '100%' }">{{ item.name }}</el-radio>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="selectedFactory">进入</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { mapActions, mapGetters, mapState } from 'vuex'
	import { ACCESS_TOKEN, ACCOUNT_FORM, USER_NAME, USER_INFO, UI_CACHE_DB_DICT_DATA, FACTORIES } from '@/store/mutation-types'
	import axios from 'axios'
	import { axios as axios2 } from '@/network/util/request'
	import { slice } from 'lodash'
	export default {
		data() {
			return {
				form: {
					account: '',
					password: '',
					inputCode: '',
					rememberMe: false,
					companyGroupDomain: '',
				},
				img: require('@/assets/images/undraw_hologram.svg'),
				rules: {
					account: [
						{ required: true, message: '请输入登录账号', trigger: 'blur' },
						{ min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' },
					],
					password: [{ required: true, message: '请输入登录密码', trigger: 'blur' }],
				},
				submiting: false,
				company: '',
				factory: '',
				dialogVisible: false,
				selectedFactoryName: '',
				factoryList: [],
				loginResponse: null,
				requestCodeSuccess: false,
				randCodeImage: '',
				currdatetime: '',
			}
		},
		computed: {
			...mapState({
				loginImage: state => state.app.factoryLoginImageUrl,
				loginCompanyImage: state => state.app.companyGroupLogoUrl,
			}),
			...mapGetters(['isPublic']),
			/**
			 * 判断是否是公有云。
			 */
			picture() {
				if (this.loginImage) {
					return this.loginImage
				}
				return this.loginCompanyImage
			},
			/**
			 * 页面标题。
			 */
			pageTitle() {
				if (this.isPublic) {
					return '凌云GMQM公有云平台'
				}

				return '凌云GMQM私有云平台'
			},
			version() {
				return process.env.NODE_ENV
			},
		},
		watch: {
			$route(to, from) {
				if (this.isPublic) {
					//公有云从url读取参数。
					var s = window.location.href.split('/')[3]
					console.log('route1233r', s.substring(0, s.Length - 1))
					this.company = this.doPouddSgn(s)
					this.factory = this.$route.query.factory
				}
			},
			selectedFactoryName(val) {
				if (val) {
					this.factory = val
				}
			},
			company(val) {
				localStorage.setItem('company', val)
				this.companyGroupDomain = val
				if (val && !this.factory) {
					this.$store.dispatch('getGlobalConfig', { companyDomain: val })
				}
			},
			factory(val) {
				localStorage.setItem('database', val)
				if (val) {
					this.$store.dispatch('getGlobalConfig', { factory: val })
				}
			},
		},
		methods: {
			...mapActions(['Login', 'Logout']),
			ds(){

			},
			/**
			 * 登录失败处理。
			 */
			requestFailed(err) {
				console.log('err', err)
				this.$message.error(((err.response || {}).data || {}).message || err.message || '请求出现错误，请稍后再试')
				this.loginBtn = false
			},
			/**
			 * 登录成功。
			 */
			loginSuccess(response) {
				const result = response.result
				const userInfo = result.userInfo

				var time = 7 * 24 * 60 * 60 * 1000

				this.$ls.set(ACCESS_TOKEN, result.token, time)
				this.$ls.set(USER_NAME, userInfo.username, time)
				this.$ls.set(USER_INFO, userInfo, time)
				this.$ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, time)
				this.$ls.set(FACTORIES, result.factories, time)

				this.$store.commit('SET_TOKEN', result.token)
				this.$store.commit('SET_INFO', userInfo)
				this.$store.commit('SET_NAME', { username: userInfo.username, realname: userInfo.realname, welcome: '欢迎使用' })
				this.$store.commit('SET_AVATAR', userInfo.avatar)
				this.$router.push({ path: '/' })
				this.$message({
					message: `欢迎回来`,
					type: 'success',
				})
				//记住密码。
				if (this.form.rememberMe) {
					this.$ls.set(ACCOUNT_FORM, this.form)
				}
			},
			/**
			 * 提交。
			 */
			submit(formName) {
				const that = this
				const loginParams = {}
				if (this.submiting) return
				this.$refs[formName].validate(valid => {
					if (valid) {
						loginParams.username = this.form.account
						loginParams.password = this.form.password
						loginParams.companyGroupDomain = this.companyGroupDomain

						if (this.isPublic) {
							loginParams.captcha = this.form.inputCode
							loginParams.checkKey = this.currdatetime
						}

						this.submiting = true
						that
							.Login(loginParams)
							.then(res => {
								if (res.success) {
									console.log('this.factory', this.factory)

									//登录成功后，如果已经指定了工厂（通过URL指定）。
									if (this.factory) {
										this.loginSuccess(res)
									} else {
										var factoryies = res.result.factories
										//如果有多个工厂，弹出对话进行工厂选择。
										if (factoryies.length > 1) {
											//遍历工厂，得到工厂集合。
											that.factoryList = factoryies.map(t => {
												return {
													name: t.name,
													dbName: t.databaseName,
												}
											})

											that.dialogVisible = true
											that.loginResponse = res
										} else {
											this.factory = factoryies[0].databaseName
											this.loginSuccess(res)
										}
									}
								}
							})
							.catch(err => {
								that.requestFailed(err)
							})
							.finally(() => {
								this.submiting = false
							})
					} else {
						return false
					}
				})
			},
			/**
			 * 祛除#
			 */
			doPouddSgn(str) {
				if (process.env.VUE_APP_VERSION == 'public') {
					if (str == '#') {
						return 'gmqm'
					} else if (str.split('').pop() == '#' && str.length > 1) {
						return str.slice(0, str.length - 1)
					}
					return str
				} else {
					return str
				}
			},

			/**
			 * 选择工厂进入。
			 */
			selectedFactory() {
				this.loginSuccess(this.loginResponse)
			},
			/**
			 * 获取记住的账号信息。
			 */
			getRememberData() {
				var ls_form = this.$ls.get(ACCOUNT_FORM)
				if (ls_form) {
					this.form = ls_form
				}
			},

			/**
			 * 获取验证码。
			 */
			handleChangeCheckCode() {
				this.currdatetime = new Date().getTime()
				axios2({ url: `sys/randomImage/${this.currdatetime}`, method: 'get' })
					.then(res => {
						//res = res.data
						if (res.success) {
							this.randCodeImage = res.result
							this.requestCodeSuccess = true
						} else {
							this.$message.error(res.message)
							this.requestCodeSuccess = false
						}
					})
					.catch(() => {
						this.requestCodeSuccess = false
					})
			},
		},
		created() {

			this.$ls.remove(ACCESS_TOKEN)
			localStorage.removeItem('database')
			localStorage.removeItem('company')

			this.getRememberData()

			if (this.isPublic) {
				//公有云从url读取参数。
				var s = window.location.href.split('/')[3]
				this.company = this.doPouddSgn(s)
				this.factory = this.$route.query.factory
				this.handleChangeCheckCode()

				console.log(this.company)

				//公有云增加验证码输入的验证。
				this.rules.inputCode = [{ required: this.isPublic, message: '请输入验证码', trigger: 'blur' }]
			} else {
				//优先从url参数获取配置，目的是为了方便通过二维码扫描结果地址查看缺陷浏览器。
				if (this.$route.query.company) {
					this.company = this.$route.query.company
					this.factory = this.$route.query.factory
				} else {
					//默认私有云从配置读取参数。
					axios.get('../privateConfig.json').then(({ data }) => {
						this.company = data.company
						this.factory = data.data
					})
				}
			}
		},
		mounted() {
			document.getElementById('usernameId').focus()
		},
	}
</script>

<style scoped lang="less">
	.signIn {
		width: 800px;
		margin: 10rem auto 0;
		/deep/ label.el-form-item__label {
			line-height: unset;
			padding-bottom: 5px;
		}
	}
	.block {
		display: block;
		width: 100%;
	}
	.title {
		overflow: hidden;
		h2 {
			font-weight: lighter;
			margin: 0;
			font-size: 18px;
		}
		h1 {
			font-size: 28px;
			margin: 0 0 20px 0;
		}
	}
	.undraw {
		width: 360px;
		height: 360px;
		margin: 4rem auto 0;
		img {
			max-height: 100%;
			max-width: 100%;
		}
	}
</style>
